import api from "../service"
import { store } from "store/configureStore"
import { hotToast } from "utils"

export const getProfiles = async (idProfile: number) => {
  await api.setToken()
  let isValid: object | any | null = await api.requestGet(
    `Perfil/GetPerfiles?idPerfil=${idProfile}`
  )
  const { data, ok } = isValid
  if (ok) {
    const { code, message } = data
    if (code != 0) {
      message && hotToast(message, "ERROR")
      return null
    }
    return data.data
  }
  return null
}

export const addProfile = async (profile: any) => {
  if (!profile.idUsuarioAct) {
    profile.idUsuarioAct = store.getState().user.idUsuario
  }
  await api.setToken()
  let isValid: object | any | null = await api.requestPost(
    `Perfil/InsertPerfil`,
    profile
  )
  const { data, ok } = isValid
  if (ok) {
    const { code, message } = data
    if (code != 0) {
      message && hotToast(message, "ERROR")
      return null
    }
    hotToast("El perfil se dío de alta correctamente", "SUCCESS")
    return true
  }
  data?.message && hotToast(data?.message,"ERROR")
  return null
}

export const updateProfile = async (id: number, profile: any) => {
  if (!profile.idUsuarioAct) {
    profile.idUsuarioAct = store.getState().user.idUsuario
  }
  await api.setToken()
  let isValid: object | any | null = await api.requestPut(
    `Perfil/UpdatePerfil/${id}`,
    profile
  )
  const { data, ok } = isValid
  if (ok) {
    const { code, message } = data
    if (code != 0) {
      message && hotToast(message, "ERROR")
      return null
    }
    hotToast("El perfil se guardó correctamente", "SUCCESS")
    return true
  }
  data?.message && hotToast(data?.message,"ERROR")
  return null
}

export const deleteProfile = async (id: number, profile: any) => {
  if (!profile.idUsuarioAct) {
    profile.idUsuarioAct = store.getState().user.idUsuario
  }
  await api.setToken()
  let isValid: object | any | null = await api.requestPut(
    `Perfil/DeletePerfil/${id}`,
    profile
  )
  const { data, ok } = isValid
  if (ok) {
    const { code, message } = data
    if (code != 0) {
      message && hotToast(message, "ERROR")
      return null
    }
    hotToast("El perfil se eliminó correctamente", "SUCCESS")
    return true
  }
  data?.message && hotToast(data?.message,"ERROR")
  return null
}
